export default function ({state, commit, dispatch}, setting) {
    if (state.loading) return;


    // context.commit('loading', true);
    // на "бою" отправляется legalEntity. Тут нужно определиться что именно отправляется id или name
    commit('loading', true);
    axios({
        method: 'post',
        url: '/tourclient/settings/RemovePaymentIntegrationSetting',
        data: {
            id: setting.Id
        }
    }).then(({data}) => {
            if (data) {
                if (data.IsDeleted) {
                    let newSettings = state.settings.filter(set => set.Id !== setting.Id);
                    commit('settings', newSettings);
                }
            }
            commit('resolves');
            commit('loading', false);
        }
    )
        .catch(err => {
            commit('resolves');
            commit('loading', false);
            dispatch('error', err, {root: true});
        })

}